import { createContext, useContext } from 'react';

export type CartItemKind = 'pairing' | 'product';

/**
 * Identifies one item's held cart change. Pairing and product ids come from
 * separate sequences and can collide, so the kind is part of the key.
 */
export function cartActionKey(kind: CartItemKind, id: number) {
  return `${kind}:${id}`;
}

/**
 * Pairing shapes all carry `ingredients`; none of the product shapes do.
 */
export function getCartItemKind(item: object): CartItemKind {
  return 'ingredients' in item ? 'pairing' : 'product';
}

/**
 * Keys of items whose add or remove has been requested but is being held
 * until the cart is ready, e.g. one chained onto an unskip that is still
 * reshuffling the order. Empty when nothing provides it.
 */
export const PendingCartActionsContext = createContext<ReadonlySet<string>>(
  new Set()
);

export function useIsCartActionPending(kind: CartItemKind, id: number) {
  return useContext(PendingCartActionsContext).has(cartActionKey(kind, id));
}
